import {
  GET_CROSS_CHECKS_HELPERS,
  GET_COMPARE_HELPERS,
  GET_COMPARE_FEE_HELPERS
} from 'src/store/mutation-types'

export default {
  [GET_CROSS_CHECKS_HELPERS] (state, crossChecksHelpers) {
    state.crossChecksHelpers = crossChecksHelpers
  },
  [GET_COMPARE_HELPERS] (state, compareHelpers) {
    state.compareHelpers = compareHelpers
  },
  [GET_COMPARE_FEE_HELPERS] (state, compareFeeHelpers) {
    state.compareFeeHelpers = compareFeeHelpers
  }
}



// WEBPACK FOOTER //
// ./src/components/compare/store/mutations.js